import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchDraftTakeawayOrders = () => {
    const filters = [
        ["Table Order", "status", "=", "Draft"],
    ];

    const params = {
        doctype: "Table Order",
        fields: JSON.stringify([
            "name",
            "customer",
            "address",
            "status",
            "table",
            "creation",
            "modified",
            "amount",
        ]),
        filters: JSON.stringify(filters),
        order_by: "modified desc",
        limit_start: 0,
        limit_page_length: 100,
    };

    return axios.get("method/frappe.client.get_list", { params });
};

export const useDraftTakeawayOrders = () => {
    return useQuery(["draftTakeawayOrders"], async () => {
        const { data } = await fetchDraftTakeawayOrders();
        return data.message || [];
    });
};


